import { ResultOf, TadaDocumentNode, VariablesOf } from "gql.tada";
import { useMemo } from "react";
import { useQuery } from "urql";
import { useGlobalContext } from "@utils/GlobalContext";

export const useContent = <Query extends TadaDocumentNode<unknown, any>>({
  query,
  variables,
  pause,
}: {
  query: Query;
  variables?: VariablesOf<Query>;
  pause?: boolean;
}) => {
  const { previewContent: preview } = useGlobalContext();
  const { locale } = useGlobalContext();
  const request = useMemo(
    () => ({
      query,
      variables: {
        ...variables,
        locale,
        preview,
      },
      pause,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [query, variables, locale, preview, pause]
  );

  return useQuery<ResultOf<Query>>(request);
};
